import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

import { GenericErrorResponseSchema } from "@common/schemas/GenericErrorSchema";

import { ApiResponseError } from "Helpers/ApiRequest";

import {
  authorizedDelete,
  authorizedGet,
  authorizedPost,
} from "@onsite_app/MobileOrderingMenu/authorizedRequests";

import {
  VoucherAssignmentSchema,
  VoucherAssignmentsSchema,
  VoucherLookupResponseSchema,
} from "./schema";

type VoucherLookupParams = { code: string } | { qrCode: string };

export const postVoucherLookup = async (params: VoucherLookupParams) => {
  try {
    const { body } = await authorizedPost({
      url: `/v1/voucher_lookups`,
      body: { voucher_lookup: snakecaseKeys(params, { deep: true }) },
    });

    return VoucherLookupResponseSchema.parse(
      camelcaseKeys(body, { deep: true }),
    ).voucherLookup;
  } catch (e) {
    if (e instanceof ApiResponseError) {
      console.error("Error looking up voucher", e.body);
      throw GenericErrorResponseSchema.parse(e.body);
    }
    throw e;
  }
};

export const fetchCartVoucherAssignments = async (cartUuid: string) => {
  const { body } = await authorizedGet({
    url: `/v1/carts/${cartUuid}/voucher_assignments`,
  });
  return VoucherAssignmentsSchema.parse(
    camelcaseKeys(body.voucher_assignments, { deep: true }),
  );
};

export const createCartVoucherAssignment = async ({
  cartUuid,
  voucherToken,
  amountInCents,
}: {
  cartUuid: string;
  voucherToken: string;
  amountInCents: number;
}) => {
  try {
    const { body } = await authorizedPost({
      url: `/v1/carts/${cartUuid}/voucher_assignments`,
      body: {
        voucher_assignment: {
          voucher_token: voucherToken,
          amount_in_cents: amountInCents,
        },
      },
    });
    return VoucherAssignmentSchema.parse(
      camelcaseKeys(body.voucher_assignment, { deep: true }),
    );
  } catch (e) {
    console.log("Error in createCartVoucherAssignment", e);

    if (e instanceof ApiResponseError) {
      console.error("Error creating voucher assignment", e.body);
      throw GenericErrorResponseSchema.parse(e.body);
    }
    throw e;
  }
};

export const removeCartVoucherAssignment = async (uuid: string) => {
  const { body } = await authorizedDelete({
    url: `/v1/voucher_assignments/${uuid}`,
  });

  return VoucherAssignmentSchema.parse(
    camelcaseKeys(body.voucher_assignment, { deep: true }),
  );
};
